(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CertificarDialogController', CertificarDialogController);

    CertificarDialogController.$inject = ['$timeout', '$http', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSAsignacion', 'CertificadoDownloadService', 'AlertService'];

    function CertificarDialogController ($timeout, $http, $scope, $stateParams, $uibModalInstance, entity, SSAsignacion, CertificadoDownloadService, AlertService) {
        var vm = this;

        entity.$promise.then(function(result) {
        	vm.sSAsignacion = result;
        });

        vm.numRecibo = "";
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;        
        vm.clear = clear;
        vm.save = save;
        vm.validateDates = validateDates;
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            SSAsignacion.cambiarFechas(vm.sSAsignacion, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
        	vm.sSAsignacion = result;
            CertificadoDownloadService.download(vm.sSAsignacion.id, vm.numRecibo, vm.sSAsignacion.prestador.matriculaParteInvariable)
            .then(function(data) {
            	onDownloadSuccess(vm.sSAsignacion.id);
            })
            .catch(function(err) {
            	onDownloadError();
            });
        }

        function onDownloadSuccess (result) {
            $scope.$emit('serviciosocialApp:sSProyectoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        	AlertService.error("Ocurrió un error al liberar al alumno.");
        }
        
        function onDownloadError () {
            vm.isSaving = false;
        	AlertService.error("Ocurrió un error al generar la carta de liberación");
        }

        vm.datePickerOpenStatus.iniPrestacion = false;
        vm.datePickerOpenStatus.finPrestacion = false;
        
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        
        function validateDates(){
        	console.log();
        	var startDate = vm.sSAsignacion.iniPrestacion;
        	var endDate = vm.sSAsignacion.finPrestacion;
        	console.log(startDate);
        	console.log(endDate);
        	$scope.editForm.finPrestacion.$setValidity("endBeforeStart", endDate > startDate);
        }


    }
})();
